import create from 'zustand';

type TenantStoreType = {
    tenant?: Company
    setTenant: (_tenant: Company) => void,
}

const useTenant = create<TenantStoreType>(
  (set) => ({
    tenant: {} as Company,
    setTenant: (tenant: Company) => set({ tenant }),
  }),
);

export default useTenant;
